import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import UserManagementMain from "components/user/UserManagementMain";
import * as api from "api/endpoints/userMangement";
import { selectUser, selectPartnersData } from "store/slices/app";

export default function UserManagementPage() {
  const dispatch = useDispatch();

  const [users, setUsers] = useState([]);
  const [roles, setUserRoles] = useState([]);
  const [gridLoading, setGridLoading] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [openInviteSentForm, setOpenInviteSentForm] = useState(false);
  const [showNotification, setShowNotification] = useState({ type: "", message: "" });

  const userData = useSelector(selectUser);
  const partnersData = useSelector(selectPartnersData);
  const companyName = userData.selectedPartner.name;

  const loadUsersDataCallback = useCallback(loadUsersData, []);

  useEffect(() => {
    setShowNotification(false);
    loadUsersDataCallback(userData.selectedPartner.id);
  }, [dispatch, loadUsersDataCallback, userData.selectedPartner.id]);

  useEffect(() => {
    loadUserRoles();
  }, []);

  async function loadUsersData(partnerId) {
    if (!partnerId) return;
    setUsers([]);
    setGridLoading(true);
    try {
      const usersData = await api.getUsers(partnerId);
      setUsers(usersData.details);
    } finally {
      setGridLoading(false);
    }
  }

  async function loadUserRoles() {
    const rolesData = await api.getUserRoles();
    setUserRoles(rolesData.details);
  }

  async function handleSubmit(data) {
    setFormOpen(false);

    var request = {
      epId: userData.selectedPartner.id,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      userRoleId: data.role,
      jobTitle: data.jobTitle,
      epPortalUserId: selectedUser?.epPortalUserId,
      phoneNumber: data.phoneNumber,
      isEmailEnabled: data.isEmailOptIn,
      isSMSEnabled: data.isSmsOptIn
    };

    try {
      if (selectedUser) {
        await api.updateInviteUser(request);
      } else {
        await api.inviteUser(request);
      }
    } catch (error) {
      const msg = error.response?.data?.errors || "Request failed";
      setShowNotification({ type: "error", message: msg });
    }

    loadUsersData(userData.selectedPartner.id);
  }

  function handleEditUser(user) {
    setSelectedUser(user);
    setFormOpen(true);
  }

  function handleInviteUser(user) {
    setSelectedUser(null);
    setFormOpen(true);
  }

  function handleFormClose() {
    setFormOpen(false);
  }

  async function handleDelete(row) {
    const data = {
      epPortalUserId: row.epPortalUserId
    };

    await api.deleteInviteUser(data);
    loadUsersData(userData.selectedPartner.id);
  }

  async function handleResend(row) {
    const data = {
      epPortalUserId: row.epPortalUserId
    };

    await api.resendInviteUser(data);
    setOpenInviteSentForm(true);
  }

  function handelInviteSentFormClose() {
    setOpenInviteSentForm(false);
  }
  function handleAlertClose() {
    setShowNotification({ type: "", message: "" });
  }

  return (
    <UserManagementMain
      loading={gridLoading}
      isPartnerChanged={partnersData.isPartnerChanged}
      users={users}
      roles={roles}
      companyName={companyName}
      selectedPartner={partnersData.selectedPartner}
      selectedUser={selectedUser}
      formOpen={formOpen}
      isAdmin={userData.isAdmin}
      openInviteSentForm={openInviteSentForm}
      showNotification={showNotification}
      onInviteSentFormClose={handelInviteSentFormClose}
      onAlertClose={handleAlertClose}
      onSubmit={handleSubmit}
      onDelete={handleDelete}
      onResend={handleResend}
      onInviteUser={handleInviteUser}
      onEditUser={handleEditUser}
      onFormClose={handleFormClose}
    />
  );
}
